import React from "react";

const TablePageIndicator = ({ currentNumber, totalNumber, className }) => {
  return (
    <div className={`${className} mb-[20px] whitespace-nowrap`}>
      Showing:{" "}
      <span className="text-[#636363]">
        {currentNumber} of {totalNumber}
      </span>
    </div>
  );
};

export default TablePageIndicator;
